import { I18n } from '@/services/i18n';

type Message = {
  hint: string;
  sendingIcebreaker: string;
};

const messages: I18n<Message> = {
  en: {
    hint: 'Sending one of these ice-breakers might cause some interesting conversation',
    sendingIcebreaker: 'Sending this ice-breaker might cause some interesting conversation:',
  },
  es: {
    hint: 'Enviar uno de estos rompehielos podría causar una conversación interesante',
    sendingIcebreaker: 'Enviar este rompehielos podría generar una conversación interesante:',
  },
  de: {
    hint: 'Das Senden eines dieser Eisbrecher könnte zu interessanten Gesprächen führen',
    sendingIcebreaker:
      'Das Senden dieses Eisbrechers könnte ein interessantes Gespräch verursachen:',
  },
};

export { messages };
